<template>
  <fieldset class="pa-content">
    <legend class="pa-content__header">
      <ul class="pa-content__toobar">
        <li
          class="pa-content__toobar-item"
          v-for="(item, index) in toobar"
          :key="index"
          @click="item.click"
          v-show="!item.hide"
        >
          <component v-if="item.icon" :is="item.icon" />
        </li>
      </ul>

      {{ title }}
    </legend>

    <div class="pa-content__body">
      <slot name="pa-content-body" />
    </div>
  </fieldset>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      default: null,
    },
    toobar: {
      type: Array,
      default: () => {},
    },
  },
};
</script>

<style lang="scss" scoped>
.pa-content {
  position: relative;
  border: none;
  background-color: #f2f2f6;
  padding: 0;
  margin: 0;

  .pa-content__header {
    background-color: #f2f2f6;
    display: flex;
    width: 100%;
    font-size: 14px;
    text-transform: uppercase;
    display: flex;
    align-items: center;
    padding: 12px 0 0;
    margin-bottom: 0.5em;

    &:before,
    &:after {
      content: "";
      border-bottom: 1px solid #e2e2e6;
      height: 9px;
      flex-grow: 1;
    }

    &:before {
      width: 5px;
      flex-grow: 0;
      margin-right: 10px;
    }

    &:after {
      margin-left: 10px;
    }
  }

  .pa-content__body {
    padding: 9px;
  }

  .pa-content__toobar {
    display: flex;
    margin: 0;
    padding: 0;
    list-style: none;
  }

  .pa-content__toobar-item {
    margin-right: 9px;
    // padding: 5px;
    display: flex;
    align-items: center;
    width: 17px;

    &:hover {
      opacity: 0.5;
    }
  }
}
</style>
